import { render } from "./PricingSection.vue?vue&type=template&id=0da075fe&scoped=true"
const script = {}

import "./PricingSection.vue?vue&type=style&index=0&id=0da075fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da075fe"]])

export default __exports__